export const STEP_IDS = [
  'team',
  'roster',
  'events',
  'recruitment',
  'loot',
  'notifications',
  'access',
] as const
